import { useMemo } from "react";

import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import contentKeys from "./contentKeys";

const useActiveContentKey = () => {
  const { activeContentKey } = useMemberToolbarStore();

  const isActive = useMemo(() => {
    switch (activeContentKey) {
      case "contact":
      case "form":
      case "messageSent":
        return contentKeys.active;
      default:
        return contentKeys.inactive;
    }
  }, [activeContentKey]);

  return isActive;
};

const useIsActive = () => {
  const activeContentKey = useActiveContentKey();
  return activeContentKey !== contentKeys.inactive;
};

export { useActiveContentKey, useIsActive };
